import styled from 'styled-components';

const ImageAvatarComment = styled.img`
  vertical-align: middle;
  width: 25px;
  height: 25px;
  border-radius: 50%;
`;

export default ImageAvatarComment;
